<div class="e-about-layout" role="main">
    <div class="e-about-text">
        <h1>Local Insight. Global Impact.</h1>
        <p>
            Using market intelligence, we partner with clients to tackle business challenges and create
            strategies that deliver success - now and in the future.
        </p>
        <p>
            We provide you answers from the ground up (bring in local insight element) to help you identify
            opportunities, understand consumers and gain a competitive edge.
        </p>
    </div>
    <div class="e-product-bar">
        <div class="e-product-tile e-product-passport">
            <h2>Passport</h2>
            <p>
                Our premier, award-winning syndicated market research database provides detailed data and
                analysis on industries, economies, countries and consumers across 781 cities, 210 countries.
            </p>
            <a href="{{passportProductPage}}" target="_blank">Learn More <i class="fa-solid fa-caret-right"></i></a>
        </div>
        <div class="e-product-tile e-product-consulting">
            <h2>Euromonitor Consulting</h2>
            <p>
                Our consulting team answers your commercial questions with data and insights generated by
                our research experts, industry knowledge and 1,200 on-the-ground analysts in 100 developed,
                emerging and frontier markets.
            </p>
            <a href="{{consultingProductPage}}" target="_blank">Learn More <i class="fa-solid fa-caret-right"></i></a>
        </div>
    </div>
</div>
